var ACTDIG = ACTDIG || (ACTDIG = {});

ACTDIG.Global = (function ($, window, document) {

  var sidebarNav = function () {
    $("#sidebar").mCustomScrollbar({
      theme: "minimal"
    });

    $('#dismiss, .nav-sidebar-overlay').on('click', function () {
      $('#sidebar').removeClass('active');
      $('.nav-sidebar-overlay').removeClass('active');
    });

    $('button.navbar-toggler').on('click', function (e) {
      e.preventDefault();
      $('#sidebar').addClass('active');
      $('.nav-sidebar-overlay').addClass('active');
      $('.collapse.in').toggleClass('in');
      $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    });
  };

  var NavMegaMenu = function () {
    var $megamenu = $('ul.megamenu');
    var height, tabHeight;

    var setHeight = function () {
      /* $megamenu.find('ul.m-tabgroup').css('height', 'auto');
      $megamenu.find('.m-tab.active .m-submenu').css('height', 'auto');

      height = $megamenu.find('.m-tab.active .m-submenu').height();
      tabHeight = $megamenu.find('ul.m-tabgroup').height();

      if (height > tabHeight) {
          $megamenu.find('ul.m-tabgroup').height(height - 25);
      } else {
          $megamenu.find('.m-tab.active .m-submenu').height(tabHeight - 25);
      } */
    };

    $(document).on('mouseover', 'li.megamenu-toggle', function (e) {
      setHeight();
      $megamenu.addClass('active');
    });

    $(document).on('mouseleave', 'li.megamenu-toggle', function (e) {
      $megamenu.removeClass('active');
    });

    $megamenu.insertAfter('header li.megamenu-toggle a');
    // $megamenu.addClass('active');

    $(document).on('mouseover', 'li.m-tab', function (e) {
      $megamenu.find('li.m-tab').removeClass('active');
      $(this).addClass('active');
      setHeight();
    });

    // TODO: debounce
    $(window).resize(function (e) {
      setHeight();
    });
  };

  return {
    init: function () {
      sidebarNav();
      NavMegaMenu();
    }
  };
})(window.jQuery, window, document);